<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" />
        <!-- Card body -->
        <form role="form" @submit.prevent="create">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error')}} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row">
              <input-date v-model="from_date" :options="{ id: 'from_date', label: 'from_date', error: fieldErrors.fromDate }"/>
              <input-date v-model="to_date" :options="{ id: 'to_date', label: 'to_date', error: fieldErrors.toDate }"/>
            </div>
             <div class="row justify-content-end">
                <div class="col">
                  <div class="card-title">
                    <h3 class="text-primary d-inline">{{ $t(`labels.add_items_to_invoice`) }}</h3>
                  </div>
                </div>
                <div class="col text-right">
                  <button class="btn btn-success btn-sm mx-2" @click.prevent="addInvoiceItemRow">
                    {{ $t(`labels.add_new_item`) }} <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
              <div class="row card-body mb-5 pt-0">
                <template v-for="(invoiceItem,index) in extraAmounts">
                  <div class="col-12">
                    <h3 class="text-primary d-inline">{{ $t(`labels.item`) }} {{index+1}}</h3>
                    <a href="#" class="text-danger mx-2" @click.prevent="removeInvoiceItemRow(index)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                  <input-text v-model="invoiceItem.key" :options="{ id: `key_${index}`, label: 'data', containerClass: 'col-12 col-md-10' }"/>
                  <input-number v-model="invoiceItem.value" :options="{ id: `value_${index}`, label: 'amount', containerClass: 'col-12 col-md-2' }"/>
                </template>
              </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`,params:{id} }"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <button type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { PLATFORMS_INVOICES_CREATE as CRUD_ACTION_CREATE } from 'actions/platforms';
  const PLATFORMS_CODE="platforms";
  const CRUD_CODE=`${PLATFORMS_CODE}.invoices`;
  export default {
    name: "PlatformInvoiceCreate",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        platformsRoutePrefix: `${PLATFORMS_CODE}`,
        platformsTransPrefix: `${PLATFORMS_CODE}`,
        id:this.$router.currentRoute.params.id,
        from_date: '',
        to_date: '',
        extraAmounts: [],
        serverError: '',
        fieldErrors: {},
        loading: false,
      }
    },
    methods: {
      prepareRequestData(){
        return {
          toDate: this.sanitizeField('to_date'),
          fromDate: this.sanitizeField('from_date'),
          extraAmounts: this.sanitizeField('extraAmounts'),
        }
      },
      create() {
        this.loading = true;
        this.$store.dispatch(CRUD_ACTION_CREATE, {
          ...this.prepareRequestData(),
          platformId:this.id,
        })
        .then(() => {
          swal({
            icon: 'success',
            text: this.$i18n.t("messages.create_successfully"),
            buttons:false,
            timer: 5000
          });
          this.$router.push({ name: `${this.routePrefix}.index`, params:{id:this.id} })
        })
        .catch(error => {
          this.loading = false;
          this.fieldErrors={};
          this.serverError='';

          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        })
      },
      addInvoiceItemRow(){
        this.extraAmounts.push({key: '', value: ''});
      },
      removeInvoiceItemRow(index){
        this.extraAmounts.splice(index,1);
      },
    }
  };
</script>
